/* eslint-env browser */

export const subtle = {};
export const getRandomValues = (array) => {
  for (let i = 0; i < array.length; i++) {
    array[i] = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
  }
  return array;
};
